module.exports = __webpack_public_path__ + "static/media/news-20.642e083d.jpg";